import { ReactComponent as EggplantIcon } from './eggplant.svg';

export default EggplantIcon;
